import { render, staticRenderFns } from "./CertificatesSummary.vue?vue&type=template&id=69ad32b8&scoped=true"
import script from "./CertificatesSummary.vue?vue&type=script&lang=js"
export * from "./CertificatesSummary.vue?vue&type=script&lang=js"
import style0 from "./CertificatesSummary.vue?vue&type=style&index=0&id=69ad32b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad32b8",
  null
  
)

export default component.exports